import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './Footer.css';

const Footer = () => {
    const linkedInUrl = "https://www.linkedin.com/company/ideracloud";
    
    return (
        <footer className="footer bg-dark">
            <Container>
                <Row className="py-4">
                    <Col md={6} className="mb-4 mb-md-0">
                        <h5 className="text-white mb-3">IDERACLOUD</h5>
                        <p className="text-light">Solutions technologiques innovantes pour votre entreprise. Experts en infrastructure réseau et transformation digitale.</p>
                        <div className="social-icons">
                            <a href={linkedInUrl} 
                               target="_blank" 
                               rel="noopener noreferrer"
                               aria-label="Suivez-nous sur LinkedIn">
                                <i className="bi bi-linkedin"></i>
                            </a>
                        </div>
                    </Col>
                    <Col md={6}>
                        <h5 className="text-white mb-3">Contact</h5>
                        <div className="contact-info text-light">
                            <p><i className="bi bi-envelope me-2"></i>contact@ideracloud.com</p>
                            <p><i className="bi bi-telephone me-2"></i>+212 660 707 129</p>
                            <p><i className="bi bi-geo-alt me-2"></i>Casablanca, Maroc</p>
                        </div>
                    </Col>
                </Row>
                <div className="border-top border-secondary pt-4 mt-4">
                    <p className="text-center text-light mb-0">
                        &copy; {new Date().getFullYear()} IDERACLOUD. Tous droits réservés.
                    </p>
                </div>
            </Container>
        </footer>
    );
};

export default Footer;